// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"KX-z","sponsoredTooltipWrapper":"LX-z","sponsoredTooltip":"MX-z","newCard":"NX-z"};